import PropTypes from 'prop-types';
import styles from './ProductPromotion.module.scss';
import classNames from 'classnames';

const ProductPromotion = ({ title, description, image, url, darkMode }) => {
  let imageNode;
  if (image && url) {
    imageNode = (
      <a href={url}>
        <img
          className={styles.productPromotionImage}
          src={image}
          alt="promotion"
        />
      </a>
    );
  } else if (image) {
    imageNode = (
      <img
        className={styles.productPromotionImage}
        src={image}
        alt="promotion"
      />
    );
  } else {
    imageNode = null;
  }

  return (
    <section
      className={classNames(styles.productPromotion, {
        'dark-mode': darkMode
      })}
    >
      <h2
        className={`title title--promotion ${
          darkMode && 'dark-mode no-border'
        }`}
      >
        <span
          className={`title__highlight ${darkMode && 'dark-mode white-border'}`}
        >
          優惠活動
        </span>
      </h2>
      <div className={`block ${darkMode && 'dark-mode'}`}>
        <h3
          className={classNames(styles.productPromotionTitle, {
            'dark-mode blue-color': darkMode
          })}
        >
          {title}
        </h3>
        <div
          className={styles.productPromotionDescription}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {imageNode}
      </div>
    </section>
  );
};

ProductPromotion.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  url: PropTypes.string
};

ProductPromotion.defaultProps = {
  image: '',
  url: ''
};

export default ProductPromotion;
